import { throttle } from 'lodash';

export let htmlHash = sessionStorage.getItem('htmlHash');


// 更新HTML的hash值
function updateHash({
    url,
    method = 'HEAD',
    headerKey = 'content-md5',
    storageKey = 'htmlHash',
    onChange
                 }: {
    url: string,
    method?: string,
    headerKey?: string,
    storageKey?: string,
    onChange?: Function
}) {
  try {
    // 通过fetch获取html的header信息，通过header方法获取hash值
    fetch(url, {
      method: method,
    }).then((res) => {
      let hash = res.headers.get(headerKey);
      const oldHash = sessionStorage.getItem(storageKey);
      // 如果没有hash值，存储hash值，则不做任何操作
      if (!hash) {
        return;
      }

      if (!oldHash) {
        sessionStorage.setItem(storageKey, hash);
      } else if (oldHash !== hash) {
        sessionStorage.setItem(storageKey, hash);
        onChange?.(hash);
      }
    });
  } catch (e) {
    console.error('获取header失败', e);
  }

}

// 节流
const throttleUpdateHash = throttle(updateHash, 10000);

// 每次聚焦和切换tab时，检查html版本是否有更新

export function versionMonitor() {

  if (process?.env?.NODE_ENV === 'development') {
    return;
  }

  window.addEventListener('focus', () => {
    throttleUpdateHash({
      url: window.location.href,
      onChange: (hash) => {
        if (htmlHash !== hash) {
          window.location.reload();
        }
      }
    });
  });

  window.addEventListener('visibilitychange', () => {
    throttleUpdateHash({
      url: window.location.href,
      onChange: (hash) => {
        if (htmlHash !== hash) {
          window.location.reload();
        }
      }
    });
  });
}

export function versionMonitorByHash() {

  if (process?.env?.NODE_ENV === 'development') {
    return;
  }

  // 路由变更时，检查html版本是否有更新
  window.addEventListener('hashchange', () => {
    throttleUpdateHash({
      url: window.location.href,
      onChange: (hash) => {
        if (htmlHash !== hash) {
          window.location.reload();
        }
      }
    });
  });
}
